import "./Notification.less";
import { Card, Typography, Badge, Spin, Row, message, Button } from "antd";
import {
  useGetNotificationsQuery,
  useMarkNotificationsMutation,
} from "../../redux/services/notification";
import { useSelector } from "react-redux";
import { EmptyCard } from "../../component";
import { CentreLogo } from "../../assets/images";

const NotificationCard = ({ notification }) => {
  return (
    <Card
      style={{
        backgroundColor: notification.is_read ? "#FFFFFF" : "#F0F7FF", // Light blue background for unread
        marginBottom: 10,
        borderRadius: 10,
        borderLeft: notification.is_read ? "" : "4px solid #1890ff", // Blue left border for unread
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {notification.logo ? (
            <img src={notification.logo} alt='Notification icon' />
          ) : (
            <img
              src={CentreLogo}
              alt='Default notification icon'
              style={{ width: 40, height: 40 }}
            />
          )}
          <p style={{ fontSize: 12, color: "#6B7280", margin: 0 }}>
            {notification.time ? notification.time : "Just now"}
          </p>
        </div>
        {!notification.is_read && <Badge color='blue' />}
      </div>
      <Typography.Title
        level={5}
        style={{
          marginTop: 8,
          fontWeight: notification.is_read ? "normal" : "500", // Make unread titles slightly bolder
        }}
      >
        {notification.title}
      </Typography.Title>
      <Typography.Paragraph style={{ margin: 0 }}>
        {notification.message}
      </Typography.Paragraph>
    </Card>
  );
};

const Notification = () => {
  const { Title } = Typography;
  const { student_id } = useSelector((state) => state.auth);

  const {
    data: notifications,
    error,
    isLoading,
    refetch,
  } = useGetNotificationsQuery({ student_id: student_id });

  const [markNotifications, { isLoading: markingLoading }] =
    useMarkNotificationsMutation();

  const handleMarkAllAsRead = async () => {
    try {
      // Check if there are any unread notifications
      const unreadNotifications = notifications?.data?.filter(
        (notification) => !notification.is_read
      );

      if (!unreadNotifications || unreadNotifications.length === 0) {
        message.info("No unread notifications to mark");
        return;
      }

      // Only send unread notification IDs
      const notificationIds = unreadNotifications.map(
        (notification) => notification.id
      );

      await markNotifications({
        notification_ids: notificationIds, // Make sure to send in the correct format expected by API
      }).unwrap();

      // Refetch notifications to update the UI
      refetch();
      message.success("All notifications marked as read");
    } catch (err) {
      console.error("Error marking notifications as read:", err);
      message.error("Failed to mark notifications as read");
    }
  };

  if (error) {
    console.error("Error fetching notifications:", error);
    return <div>Error loading notifications. Please try again.</div>;
  }

  return (
    <Spin spinning={isLoading || markingLoading}>
      <div className='notification-container'>
        <Row justify='space-between' style={{ marginBottom: 20 }}>
          <Title className='title'>Today</Title>
          <Button
            type='link'
            className='mark-all'
            onClick={handleMarkAllAsRead}
            disabled={
              !notifications?.data?.some(
                (notification) => !notification.is_read
              )
            }
          >
            Mark all as read
          </Button>
        </Row>
        {notifications?.data?.length > 0 ? (
          notifications?.data?.map((notification) => (
            <NotificationCard
              key={notification.id}
              notification={notification}
            />
          ))
        ) : (
          <EmptyCard text='No Notifications' />
        )}
      </div>
    </Spin>
  );
};

export default Notification;
